import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { motion } from 'framer-motion';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to error reporting service
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)'
          }}>
          <Container maxWidth='sm'>
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
              <Box sx={{ textAlign: 'center' }}>
                <ErrorOutlineIcon
                  sx={{
                    fontSize: 80,
                    color: '#d32f2f',
                    mb: 3
                  }}
                />
                <Typography
                  variant='h3'
                  sx={{
                    mb: 2,
                    fontWeight: 700,
                    color: '#1a1a1a'
                  }}>
                  Etwas ist schief gelaufen
                </Typography>
                <Typography
                  variant='body1'
                  sx={{
                    mb: 4,
                    color: '#666',
                    lineHeight: 1.7
                  }}>
                  Entschuldigung, es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut oder kehren Sie zur Startseite zurück.
                </Typography>
                {process.env.NODE_ENV === 'development' && this.state.error && (
                  <Box
                    sx={{
                      mb: 4,
                      p: 2,
                      background: '#fff',
                      borderRadius: 2,
                      border: '1px solid #e0e0e0',
                      textAlign: 'left',
                      overflow: 'auto',
                      maxHeight: '200px'
                    }}>
                    <Typography
                      variant='body2'
                      component='pre'
                      sx={{
                        color: '#d32f2f',
                        fontSize: '0.875rem',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word'
                      }}>
                      {this.state.error.toString()}
                    </Typography>
                  </Box>
                )}
                <Button
                  variant='contained'
                  size='large'
                  onClick={this.handleReset}
                  sx={{
                    px: 4,
                    py: 1.5,
                    background: '#000',
                    color: '#fff',
                    fontWeight: 600,
                    '&:hover': {
                      background: '#333'
                    }
                  }}>
                  Zurück zur Startseite
                </Button>
              </Box>
            </motion.div>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
